<!--  -->
<template>
  <div>
    <ul class="lit03">
      <li v-for="item in devicenav" :key="item.title">
        <div class="cont_r_b04">
          <div class="cont_r_b05">
            <img :src="item.img" width="158" height="109">
          </div>
          <div class="cont_r_b06">
            <div class="cont_r_b07">
              <p></p>
            </div>
            <div class="cont_r_b09">
              <p></p>
              <p>
                <span style="font-family:&quot;color:black;">
                  <strong>
                    <u>{{item.title}}</u>
                  </strong>
                </span>
              </p>
              <p>
                <span style="font-family:&quot;color:black;">
                  <span></span>
                </span>
                <span style="font-family:&quot;color:black;">
                  <br>
                </span>
              </p>
              <p style="font-family:&quot;color:black;" v-html="item.word"></p>
              <p></p>
            </div>
          </div>
          <div class="clear"></div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  data() {
    return {
      devicenav: [{
      title: 'COMPLETE EQUIPMENTS',
      word: 'Continues casting and rolling production line for Aluminum Rods<br />Continues casting and rolling production line for Copper Tubes<br />Finishing production line for Steel Bars',
      img: require('../../../assets/img/common/home7.jpg')
    },
    {
      title: 'PROCESSING EQUIPMENTS FOR NONFERROUS METALS',
      word: 'High Speed Spinner Block<br />Level Rewinding Machine<br />Planetary Rolling Mill<br />Multi-Rolling Mill<br />Combined Drawing Machine<br />Machines Group of Extrusion Press<br />Bell Type Annealing Furnace<br />Continues Annealing Furnace',
      img: require('../../../assets/img/common/home8.jpg')
    },
    {
      title: 'EQUIPMENTS FOR PLASTIC OF EXTRUSION AND INJECTION',
      word: 'Extrusion Machine<br />Extrusion Mould<br />Inject Mould<br />Screw and Barrel',
      img: require('../../../assets/img/common/home9.jpg')
    },
    {
      title: 'PROCESSING EQUIPMENT FOR STEEL PRODUCTS',
      word: 'Multi-Rolling Mill for Steel<br />Continues casting machine for Steel Billet',
      img: require('../../../assets/img/common/home10.jpg')
    }
  ]
    };
  },

  components: {},

  methods: {}
};
</script>
<style lang='stylus' rel='stylesheet/stylus'>
</style>


// WEBPACK FOOTER //
// src/components/en/device/devicesy.vue